import React from 'react';
import AirCompressorsAddEdit from './air-compressors-add-edit';
import AirCompressorsAddEditModal from './air-compressors-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { AIR_COMPRESSORS_ADD_EDIT } = MODAL_TYPES;

const AirCompressorsModals = () => {
  return (
    <>
      <AirCompressorsAddEdit modalId={AIR_COMPRESSORS_ADD_EDIT} />
      <AirCompressorsAddEditModal />
    </>
  );
};

export default AirCompressorsModals;
